import React, { useEffect } from "react";
import TableAutoComponent from "../../components/complex/crud/TableAutoComponent";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import generateTableConfigs from "../../utils/TableConfigGenerator";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";

import useSelectorDialogControl from "../../custom_hooks/complex/useSelectorDialogControl";
import useIsMobile from "../../hooks/useIsMobile";

const apiName = "masterdata/kendaraanpemakaian";
const orderBy = "nama";
const orderMethod = "ASC";
const additionalParams = {};

const customColumns = [];

const configs = [
  // add_configs
  {
    name: "Kode",
    field: "kode",
    type: "text_plain",
    table: true,
    filter: true,
  },
  {
    name: "Nama",
    field: "nama",
    type: "text_plain",
    table: true,
    filter: true,
  },
];

const filterConfigs = generateFilterConfigs(configs);
const tableConfigs = generateTableConfigs(configs);

const onReloadSuccess = (data) => {
  const inputElement = document.querySelector("#filterInput");
  if (inputElement) {
    inputElement.focus();
  }
};

const PemakaianSelectorDialog = (props) => {
  const single = props.single ?? true;
  const { title } = props;
  const isMobile = useIsMobile();

  const {
    toast,
    listData,
    paging,
    loading,
    setListData,
    selectedRows,
    setSelectedRows,
    refineValue,
    reloadListData,
    handleOnFilter,
    handleOnPage,
    handleSelectionChange,
  } = useSelectorDialogControl({
    apiName,
    orderBy,
    orderMethod,
    additionalParams,
    visible: props.visible,
    onReloadSuccess,
    additionalFilter: props.additionalFilter,
  });

  const dialogFooter = (
    <div className="col-center-center w-100">
      {!isMobile ? (
        <Paginator
          first={parseInt(paging.take) * parseInt(paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 8, 10, 20, 50]}
          onPageChange={handleOnPage}
        />
      ) : (
        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 8, 10, 20, 50]}
          template={{
            layout: "PrevPageLink CurrentPageReport NextPageLink RowsPerPageDropdown",
          }}
          onPageChange={handleOnPage}
          pt={{
            prevPageButton: {
              className:
                "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
            },
            nextPageButton: {
              className:
                "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
            },
            current: {
              className: "bg-white-100 !m-0 max-h-[22px] text-sm",
            },
            rowsPerPageDropdown: {
              className: "bg-white-100 !m-0 max-h-[22px]",
            },
          }}
        />
      )}
      <div className="row-end-end w-100">
        <Button
          label="Cancel"
          icon="pi pi-times"
          outlined
          onClick={props.onHide}
        />
        <Button
          label="Pilih"
          icon="pi pi-check"
          onClick={(e) => {
            const refinedValue = refineValue(selectedRows);
            props.onConfirm(e, refinedValue);
          }}
        />
      </div>
    </div>
  );

  return (
    <Dialog
      visible={props.visible}
      header={title}
      modal
      className={`p-fluid w-[44rem] min-h-[30rem]`}
      footer={dialogFooter}
      onHide={props.onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <div className={`col-start-start w-100 gap-3 pt-1`}>
        {filterConfigs && filterConfigs.length > 0 && (
          <FilterComponent onFilter={handleOnFilter} configs={filterConfigs} />
        )}
        <div className={`col-center-center w-100 gap-2`}>
          <TableAutoComponent
            singleMode={single}
            selection={selectedRows}
            onSelectionChange={handleSelectionChange}
            configs={tableConfigs}
            loading={loading}
            value={listData}
            customColumns={customColumns}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default PemakaianSelectorDialog;
